/* Scoped desktop preview behavior. Navigation open/close remains owned by the theme. */
(() => {
  const desktop = window.matchMedia('(min-width: 1024px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  class InfoMenu extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('shopify:block:select', event => {
        if (!desktop.matches) return;
        const block = event.target.closest('[data-info-block]');
        if (!block || !this.contains(block)) return;
        const panel = this.closest('[data-mosasaur-info-panel]');
        const surface = this.closest('.m-header__desktop')?.siswaySurface;
        const item = surface && [...surface.items].find(entry => entry.panel === panel);
        if (item) surface.open(item);
        const link = block.querySelector('[data-info-topic]');
        if (link) this.select(link.dataset.infoTopic, false);
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('mosasaur-contact-desktop')) customElements.define('mosasaur-contact-desktop', class extends InfoMenu {});
  if (!customElements.get('mosasaur-about-desktop')) customElements.define('mosasaur-about-desktop', class extends InfoMenu {
    connectedCallback() {
      super.connectedCallback();
      const options = { signal: this.controller.signal };
      this.links = [...this.querySelectorAll('[data-info-topic]')];
      this.previews = [...this.querySelectorAll('[data-info-preview]')];
      this.links.forEach(link => {
        link.addEventListener('pointerenter', event => {
          if (desktop.matches && event.pointerType === 'mouse') this.select(link.dataset.infoTopic);
        }, options);
        link.addEventListener('focus', () => {
          if (desktop.matches) this.select(link.dataset.infoTopic);
        }, options);
      });
      this.select('factory', false);
      this.observer?.disconnect();
      const panel = this.closest('[data-mosasaur-info-panel]');
      if (panel) {
        this.observer = new MutationObserver(() => {
          if (panel.getAttribute('aria-hidden') === 'true') this.select('factory', false);
        });
        this.observer.observe(panel, { attributes: true, attributeFilter: ['aria-hidden'] });
      }
    }
    select(topic, animate = true) {
      if (this.activeTopic === topic) return;
      this.activeTopic = topic;
      this.links.forEach(link => { link.dataset.selected = String(link.dataset.infoTopic === topic); });
      this.previews.forEach(preview => {
        const selected = preview.dataset.infoPreview === topic;
        preview.motion?.cancel();
        preview.dataset.selected = String(selected);
        preview.setAttribute('aria-hidden', String(!selected));
        preview.inert = !selected;
        if (selected && animate && desktop.matches && !reduced.matches) {
          preview.motion = preview.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' });
        }
      });
    }
    disconnectedCallback() {
      super.disconnectedCallback();
      this.observer?.disconnect();
      this.previews?.forEach(preview => preview.motion?.cancel());
      this.activeTopic = null;
    }
  });
})();
